import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProvidersService } from 'src/app/services/providers.service';


@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.scss']
})
export class ProvidersComponent implements OnInit {

  public displayForm = false
  public providerForm: FormGroup;
  public submitted = false;
  public isEditForm = false;

  public providers = [];

  constructor(private providersService : ProvidersService) { }

  ngOnInit() {
    this.providerForm = new FormGroup({
      'name': new FormControl('', [Validators.required]),
      'email': new FormControl(''),
      'phone': new FormControl('', [Validators.required]),
      'address': new FormControl(''),
      'comments': new FormControl(''),
      'id': new FormControl('')
    });
    this.providersService.getProviders().subscribe((providersnapshot) => {
      this.providers = [];
      providersnapshot.forEach((providerData: any) => {
        this.providers.push({
          id: providerData.payload.doc.id,
          data: providerData.payload.doc.data()
        });
      })
    });
  }

  AddNewProvider() {
    this.displayForm = true
  }

  editProvider(provider){
    const formElement = document.querySelector("#provider-form");
    if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'end' })
    this.providerForm.patchValue({id: provider.id, ...provider.data});
    this.displayForm = true;
    this.isEditForm = true;
  }

  deleteProvider(){
      this.providersService.deleteProvider(this.f.id.value);
      this.onReset()
    }

  onSubmit(){
    this.submitted = true;
    if (this.providerForm.valid){
      if (this.isEditForm) {
        this.providersService.updateProvider(this.providerForm.value)
        .then(() => {
          this.onReset()
        })
      }
      else {
        this.providersService.createProvider(this.providerForm.value)
        .then(() => {
          this.onReset()
        })
      }   
    }
  }

  onReset(){
    this.submitted = false;
    this.providerForm.reset();
    this.displayForm = false;
    this.isEditForm = false;
  }

  get f(){
    return this.providerForm.controls;
  }

  get formSubmitValue(){
    if (this.isEditForm) {
      return "Actualizar Proveedor"
    }
    else {
      return "Añadir Proveedor"
    }
  }

}
